import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function BranchCashInReport() {
  return <ReportForm reportAPI={ ReportAPI.BRANCH_CASH_IN } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/BranchCashInReport.js